import React from 'react'

export default class IconsRedo extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    d='M12.5 11.6667L16.6667 7.5L12.5 3.33333'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M16.6663 7.5H7.91634C6.70077 7.5 5.53498 7.98289 4.67544 8.84243C3.81589 9.70197 3.33301 10.8678 3.33301 12.0833C3.33301 12.6852 3.45156 13.2812 3.68189 13.8373C3.91223 14.3934 4.24983 14.8986 4.67544 15.3242C5.53498 16.1838 6.70077 16.6667 7.91634 16.6667H10.833'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
